import { FC } from 'react';
import { useSnapshot } from 'valtio';
import DetectionComponent from '../components/Detections/DetectionComponent';
import ExecutiveStore from '../stores/executive-store';

const DetectionsContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const { coveredCategories, uncoveredCategories, preventCategories } =
    useSnapshot(ExecutiveStore);

  return (
    <DetectionComponent
      coveredCategories={coveredCategories}
      uncoveredCategories={uncoveredCategories}
      preventCategories={preventCategories}
    />
  );
};

export default DetectionsContainer;
